import client from './client';
import type { Model3D } from '@dtwin/shared';

export async function fetchModels(sceneId: string): Promise<Model3D[]> {
  const { data } = await client.get(`/models/scene/${sceneId}`);
  return data;
}

/** 2026-09-14：贴图（maps）批量上传——按原文件名存入服务器 uploads 根目录，FBX 外链贴图按 basename 自动匹配 */
export async function uploadTextures(files: File[]): Promise<{ uploaded: string[]; count: number }> {
  const form = new FormData();
  files.forEach((f) => form.append('files', f));
  const { data } = await client.post('/models/textures', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 600000,
  });
  return data;
}

export async function uploadModel(
  sceneId: string,
  file: File,
  onProgress?: (percent: number) => void,
  opts?: { rightsDeclared?: boolean },
): Promise<Model3D> {
  const form = new FormData();
  form.append('file', file);
  form.append('sceneId', sceneId);
  // M1：权属声明（服务端强校验：模型导入必须为 true）
  form.append('rightsDeclared', opts?.rightsDeclared === true ? 'true' : 'false');
  const { data } = await client.post('/models/upload', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 600000,
    onUploadProgress: (e) => {
      if (e.total && onProgress) {
        onProgress(Math.round((e.loaded * 100) / e.total));
      }
    },
  });
  return data;
}

export async function updateModel(id: string, body: Partial<Model3D>): Promise<Model3D> {
  const { data } = await client.put(`/models/${id}`, body);
  return data;
}

export async function createModel(body: Partial<Model3D>): Promise<Model3D> {
  const { data } = await client.post('/models', body);
  return data;
}

export async function deleteModel(id: string): Promise<void> {
  await client.delete(`/models/${id}`);
}

export async function uploadEnvMap(
  file: File,
  onProgress?: (percent: number) => void,
): Promise<{ url: string }> {
  const form = new FormData();
  form.append('file', file);
  const { data } = await client.post('/models/upload-env-map', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 600000,
    onUploadProgress: (e) => {
      if (e.total && onProgress) {
        onProgress(Math.round((e.loaded * 100) / e.total));
      }
    },
  });
  return data;
}
